import { Tooltip } from '@mui/material';
import React from 'react';
import {
  formatInstantInTimeZone,
  formatInStoreTimeZone,
  storeWallClockToUtcInstant,
  stripIsoFormatting,
} from '../utils/dateTime';

interface StoreDateTimeProps {
  value: string | null | undefined;
  storeTimeZone: string | undefined;
  className?: string;
}

export const StoreDateTime: React.FC<StoreDateTimeProps> = ({
  value,
  storeTimeZone,
  className,
}) => {
  if (!value) return null;

  const storeDisplay = formatInStoreTimeZone(value, storeTimeZone);

  if (!storeTimeZone) {
    return <span className={className}>{storeDisplay}</span>;
  }

  const instant = storeWallClockToUtcInstant(value, storeTimeZone);
  const browserDisplay =
    instant && !isNaN(instant.getTime())
      ? formatInstantInTimeZone(instant)
      : stripIsoFormatting(value);

  return (
    <Tooltip title={<span>In your time: {browserDisplay}</span>} arrow>
      <span className={className}>{storeDisplay}</span>
    </Tooltip>
  );
};
